<div class="token-unlock-container">
  <div class="icon-close" (click)="closeModal()">
    x
  </div>
  <div class="warning">
    <svg width="40" height="36" viewBox="0 0 40 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.3125 35.75H35.6875C38.8958 35.75 40.8958 32.2708 39.2917 29.5L23.6042 2.39584C22 -0.37499 18 -0.37499 16.3958 2.39584L0.708332 29.5C-0.895835 32.2708 1.10416 35.75 4.3125 35.75ZM20 21.1667C18.8542 21.1667 17.9167 20.2292 17.9167 19.0833V14.9167C17.9167 13.7708 18.8542 12.8333 20 12.8333C21.1458 12.8333 22.0833 13.7708 22.0833 14.9167V19.0833C22.0833 20.2292 21.1458 21.1667 20 21.1667ZM22.0833 29.5H17.9167V25.3333H22.0833V29.5Z" fill="#FFB82E"/>
    </svg>
  </div>
  
  <div class="title" [innerHTML]="title"></div>
  <div class="message mt-3" [innerHTML]="paragraph"></div>
 
  <div class="inputs-container mt-3 grid-error">
   <div class="container-code">
      <code-input [isCodeHidden]="false"
        [codeLength]="6"
        (codeChanged)="onCodeChanged($event)"
        (codeCompleted)="onCodeCompleted($event)">
      </code-input>
      <span *ngIf="errorCodeIntroduced">{{'Codigo de seguridad incorrecto' | translate}}</span>
    </div>
  </div>

  <div class="btns-container mt-4">
    <button class="btn-outline-info btn resend-code" (click)="resendCodeEmail()" [disabled]="codeSent" >
      <ng-container *ngIf="resending; else resend">
        <div class="loading label-btn">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{"Reenviando" | translate}}...
        </div>
      </ng-container >
      <ng-template #resend>
        <span>{{'Reenviar codigo' | translate}}</span>
      </ng-template>
      
    
    </button>
    <button class="btn-primary btn" [disabled]="!validCode" (click)="validateCode()">

      <ng-container *ngIf="validating; else continue">
        <div class="loading label-btn">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{'Validando'|translate}}...
        </div>
      </ng-container >
      <ng-template #continue>
        <span>{{'Continuar' | translate}}</span>
      </ng-template>
      
    </button>
  </div>
</div>
